import { Button } from "@mui/material";
import { useContext } from "react";
import { FirmaElectronicaContext } from "../context/firmaElectronicaContext";
import { ButtonOptionsProps } from "../interfaces/firmaInterfaces";

export const ButtonOption = ({
  label = "",
  solicituddemandaRes,
  ...props
}: ButtonOptionsProps) => {
  const { statusFirma } = useContext(FirmaElectronicaContext);

  return (
    <Button
      disabled={
        solicituddemandaRes?.isCompletedProcess &&
        statusFirma?.signed?.length &&
        statusFirma?.signed[0]?.data?.length
          ? true
          : false
      }
      {...props}
    >
      {label}
    </Button>
  );
};
